import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import useFetchDeclarations from '../hooks/useFetchDeclarations';
import { sanitizeText } from '../utils/SanitizeText';

import Loader from '../components/Loader';
import ListDeclaration from '../components/ListDeclaration';

const DeclarationList = () => {
    const { declarations, fetchDeclarations, loading, error } = useFetchDeclarations();

    const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchDeclarations();
    }, [fetchDeclarations]);

    // if (loading) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    if (error) {
        return <div>Erreur : {error}</div>;
    }

    const declarationsSain = declarations
        .map(declaration => ({
            ...declaration,
            Libelle: sanitizeText(declaration.Libelle)
        }));

    return (
        <div class="flex-1 p-6 lg:p-10">
            <div class="gap-6 grid grid-cols-12">
                <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                    <div class="col-span-12">
                        <div class="flex items-center bg-gray-900 drop-shadow-xl mb-6 px-8 rounded-lg w-full min-h-20">
                            <div id="url" class="flex gap-x-2 font-semibold text-gray-400 text-sm sm:text-lg">
                                <Link to="/declarations" class="hover:text-white decoration-orange-600 hover:underline hover:underline-offset-2 transition hover:translate-y-[-2px] duration-300">Declarations</Link>
                                <span class="cursor-default">/</span>
                            </div>
                        </div>
                        <ListDeclaration lstDeclarations={declarationsSain} loading={loading} showAdd={false} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeclarationList;
